<template>
  <section class="content">
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="goBackInfo">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h5>
              <span class="text-red">＊</span>
              完成步驟後，再至
              <router-link :to="goToBuild">
                菜單建置
              </router-link>
              建立菜單
            </h5>
            <h5>
              <span class="text-red">＊</span>
              若無套餐需求，只需完成步驟 1~5
            </h5>
          </div>
          <!-- /.box-header -->
          <div class="box-body col-xs-12 text-center">
            <div class="col-xs-12">
              <router-link :to="goToBindingPos">
                <button class="btn btn-detail-edit">
                  1 - 建立菜單庫 (綁定商品料號)
                </button>
              </router-link>
            </div>
            <div class="col-xs-12 col-md-6">
              <router-link :to="goToOption">
                <button class="btn-a-o btn-detail-edit">
                  2 - 配料 (option)
                </button>
              </router-link>
            </div>
            <div class="col-xs-12 col-md-6">
              <router-link :to="goToAdjust">
                <button class="btn-p-com btn-detail-edit">
                  3 - 配料群組 (adjust)
                </button>
              </router-link>
            </div>
            <div class="col-xs-12 col-md-6">
              <router-link :to="goToCategory">
                <button class="btn-com-price btn-detail-edit">
                  4 - 商品分類 (category)
                </button>
              </router-link>
            </div>
            <div class="col-xs-12 col-md-6">
              <router-link :to="goToProduct">
                <button class="btn-c-p btn-detail-edit">
                  5 - 商品 (product)
                </button>
              </router-link>
            </div>
            <div class="col-xs-12 col-md-6">
              <router-link :to="goToBlock">
                <button class="btn-a-o btn-detail-edit">
                  6 - 品項選擇區 (block)
                </button>
              </router-link>
            </div>
            <div class="col-xs-12 col-md-6">
              <router-link :to="goToPackage">
                <button class="btn-p-com btn-detail-edit">
                  7 - 套餐 (package)
                </button>
              </router-link>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'MenuStep',
  data () {
    return {
      goToMap: [
        {
          name: 'BindingPos',
          type: 1
        },
        {
          name: 'brandMenuTable',
          type: 1
        },
        {
          name: 'StoreMenuBindingPos',
          type: 2
        },
        {
          name: 'StoreMenuBuild',
          type: 2
        },
        {
          name: 'StoreMenuOption',
          type: 2
        },
        {
          name: 'upOption',
          type: 1
        }
      ]
    }
  },
  extends: NdExtendHandleMenu,
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    goToAdjust () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuAdjust'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'upAdjust'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToBindingPos () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuBindingPos'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'BindingPos'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToBlock () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuBlock'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'upBlock'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToBuild () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuBuild'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'brandMenuTable'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToCategory () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuCategory'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'upCategory'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToOption () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuOption'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'upOption'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToPackage () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuPackage'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'upPackage'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    },
    goToProduct () {
      let to = {
        name: '',
        params: {},
        query: {}
      }
      if (this.isStore && this.getRoleType === 99) {
        to.name = 'StoreMenuProduct'
        to.params.brand_id = this.$route.params.brand_id
        to.params.store_id = this.$route.params.store_id
      } else {
        to.name = 'upProduct'
        to.params.brand_id = this.$route.params.brand_id
      }
      return to
    }
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>

<style lang="sass" scoped>
.btn-detail-edit
  color: #444
  border: 0px
  border-radius: 4px
  margin: 10px
  padding: 20px
  width: calc(100% - 40px)
  font-weight: 600
  i
    margin-bottom: 20px
    font-size: 40px
</style>



// WEBPACK FOOTER //
// menu-step.vue?3a8d7ae0